import { Component, Vue, Prop } from 'vue-property-decorator';
import LooseObject from '@/models/Objects/LooseObject';

@Component
export default class Title extends Vue {
    @Prop() public props!: LooseObject;
}
